import React, { Fragment } from 'react';
import PDFViewer from './PDFViewer';
import { useLocation } from 'react-router';
import { Helmet } from 'react-helmet';

const PitchDeck2024 = () => {
  const pathName = useLocation().pathname;
  const filePath = () => {
    if (pathName.includes('short')) {
      return 'short';
    } else {
      return 'full';
    }
  };
  return (
    <Fragment>
      <Helmet>
        <title>Autzu - Start Drivesharing Today</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <PDFViewer version={filePath()} />
    </Fragment>
  );
};

export default PitchDeck2024;



// WEBPACK FOOTER //
// ./src/components/PitchDeck/PitchDeck2024.js